if (!customElements.get('ac-brand-models')) {
  class AcBrandModels extends HTMLElement {
    connectedCallback() {
      this.selectEl = this.querySelector('select');
      this._previousValue = this.selectEl?.value || '';
      this.onChange = this.onChange.bind(this);
      this.selectEl?.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.selectEl?.removeEventListener('change', this.onChange);
    }

    onChange() {
      const option = this.selectEl?.selectedOptions?.[0];
      if (!option) return;
      const previous = this._previousValue;
      this._previousValue = option.value;

      if (option.dataset.same === 'true') {
        const root = this.closest('product-info') || this.closest('.product__info-container') || document;
        const native = root.querySelector('variant-selects select');
        if (!native) return;
        if (native.value !== option.dataset.optionValue) {
          native.value = option.dataset.optionValue;
          native.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      if (!option.dataset.url) return;

      const modal = this.closest('quick-add-modal');
      if (modal && typeof modal.loadFromUrl === 'function') {
        modal.loadFromUrl(option.dataset.url).catch(() => {
          if (previous) this.selectEl.value = previous;
          this._previousValue = previous;
        });
        return;
      }

      window.location.href = option.dataset.url;
    }
  }

  customElements.define('ac-brand-models', AcBrandModels);
}
